const GRADIENT_START_COLOR_RGB = { r: 252, g: 254, b: 240 };
const GRADIENT_END_COLOR_RGB = { r: 102, g: 199, b: 83 };
const GRADIENT_RED_COLOR_RGB = { r: 229, g: 97, b: 95 };

const GRADIENT_START_COLOR_RGB_DARK = { r: 79, g: 166, b: 62 };
const GRADIENT_END_COLOR_RGB_DARK = { r: 20, g: 80, b: 10 };

export const getCellColor = (
  displayValue,
  maxLossValue,
  doMarkNegativeValues,
  maxProfitValue,
  minProfitValue,
  isDarkMode
) => {
  const _maxProfitValue = maxProfitValue || 1000;
  const _minProfitValue = minProfitValue || 0;

  const minLossValue = 0;
  maxLossValue = maxLossValue || 0;

  let rgb;
  let alpha;
  let endR, endG, endB;
  if (isDarkMode) {
    endR = GRADIENT_END_COLOR_RGB_DARK.r;
    endG = GRADIENT_END_COLOR_RGB_DARK.g;
    endB = GRADIENT_END_COLOR_RGB_DARK.b;
  } else {
    endR = GRADIENT_END_COLOR_RGB.r;
    endG = GRADIENT_END_COLOR_RGB.g;
    endB = GRADIENT_END_COLOR_RGB.b;
  }
  if (displayValue > 0) {
    // Green:
    rgb = `${endR}, ${endG}, ${endB}`;
    if (_minProfitValue == _maxProfitValue) {
      alpha = 0.5;
    } else {
      alpha = ((displayValue - _minProfitValue) / (_maxProfitValue - _minProfitValue)) * 0.8 + 0.2;
    }
  } else {
    // Red:
    if (doMarkNegativeValues == null || doMarkNegativeValues == true) {
      rgb = `${GRADIENT_RED_COLOR_RGB.r}, ${GRADIENT_RED_COLOR_RGB.g}, ${GRADIENT_RED_COLOR_RGB.b}`;
      if (maxLossValue == minLossValue) {
        alpha = 0.6;
      } else {
        alpha = ((displayValue - maxLossValue) / (maxLossValue - minLossValue)) * 0.4 + 0.6;
      }
    }
  }

  return "rgba(" + rgb + ", " + alpha + ")";
};

export const getHeaderColor = (index, total, isDarkMode) => {
  let startR, startG, startB, endR, endG, endB;
  if (isDarkMode) {
    startR = GRADIENT_START_COLOR_RGB_DARK.r;
    startG = GRADIENT_START_COLOR_RGB_DARK.g;
    startB = GRADIENT_START_COLOR_RGB_DARK.b;
    endR = GRADIENT_END_COLOR_RGB_DARK.r;
    endG = GRADIENT_END_COLOR_RGB_DARK.g;
    endB = GRADIENT_END_COLOR_RGB_DARK.b;
  } else {
    startR = GRADIENT_START_COLOR_RGB.r;
    startG = GRADIENT_START_COLOR_RGB.g;
    startB = GRADIENT_START_COLOR_RGB.b;
    endR = GRADIENT_END_COLOR_RGB.r;
    endG = GRADIENT_END_COLOR_RGB.g;
    endB = GRADIENT_END_COLOR_RGB.b;
  }
  if (total <= 1) return `rgb(${startR}, ${startG}, ${startB})`;
  const ratio = index / (total - 1);

  const r = Math.round(startR + (endR - startR) * ratio);
  const g = Math.round(startG + (endG - startG) * ratio);
  const b = Math.round(startB + (endB - startB) * ratio);

  return `rgb(${r}, ${g}, ${b})`;
};
